import styled from 'styled-components';

export const Container = styled.div<{ direction: 'top' | 'bottom' }>`
  display: flex;
  flex-direction: ${(props) =>
    props.direction === 'top'
      ? 'column'
      : 'column-reverse'}; /* This will make the content expand upwards */
  align-items: center;
  width: 100%;
`;

export const HeaderContainer = styled.div`
  background: none;
  cursor: pointer;
  text-align: center;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderContent = styled.div`
  width: 100%;
  padding-right: 4px;
`;

export const ContentContainer = styled.div<{
  isOpen: boolean;
  maxHeight: string;
}>`
  overflow: hidden;
  transition: max-height 0.5s ease-out;
  max-height: ${(props) => (props.isOpen ? props.maxHeight : '0')};
  width: 100%;
  margin-bottom: 4px;
`;

export const Chevron = styled.div<{
  direction: 'top' | 'right' | 'bottom' | 'left';
}>`
  height: 16px;
  width: 16px;

  transition: all 0.25s ease-in-out;

  transform: ${(p) => p.direction === 'top' && 'rotate(180deg)'};
  transform: ${(p) => p.direction === 'right' && '-rotate(90deg)'};
  transform: ${(p) => p.direction === 'bottom' && 'rotate(0deg)'};
  transform: ${(p) => p.direction === 'left' && 'rotate(90deg)'};
`;
